import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Identity of the account this tab believes it is signed in as (set by AuthContext).
let currentUserId = null;
let onIdentityChange = null;
export function bindSessionIdentity(userId, handler) {
  currentUserId = userId || null;
  onIdentityChange = handler;
}

// Every authenticated response carries X-DV-User (the account the browser cookie belongs to).
// If it differs from the account this tab rendered, the session was switched in another tab:
// drop everything this tab knows and reload so nothing from the previous account is shown.
api.interceptors.response.use(
  (res) => {
    const uid = res.headers?.["x-dv-user"];
    if (uid && currentUserId && uid !== currentUserId && onIdentityChange) onIdentityChange(uid);
    return res;
  },
  (err) => {
    const url = err.config?.url || "";
    const isPublic = /^\/?(share|sign|protected|verify|auth\/(login|register|2fa|passkey|google|forgot|reset))/.test(url);
    if (err.response?.status === 401 && !isPublic && currentUserId && onIdentityChange) onIdentityChange(null);
    return Promise.reject(err);
  }
);

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
